import type { FlowViewMode } from '../types';
import { Button } from '@art-of-hospitality-solutions-llc/ui-kit/components/button';

export interface ViewTogglePaneProps {
  activeView: FlowViewMode;
  onViewChange: (view: FlowViewMode) => void;
  className?: string;
}

const VIEWS: { value: FlowViewMode; label: string }[] = [
  { value: 'flow', label: 'Flow' },
  { value: 'detailed', label: 'Detailed' },
];

export function ViewTogglePane({
  activeView,
  onViewChange,
  className,
}: ViewTogglePaneProps) {
  return (
    <div className={className ?? 'gap- flex items-center'}>
      <span className="text-xs leading-5 font-medium text-white">View</span>
      <div className="flex items-stretch gap-1 rounded-lg bg-zinc-900 p-1">
        {VIEWS.map((view) => (
          <Button
            key={view.value}
            variant={activeView === view.value ? 'secondary' : 'ghost'}
            size="sm"
            onClick={() => onViewChange(view.value)}
          >
            {view.label}
          </Button>
        ))}
      </div>
    </div>
  );
}
